export default {
  state: {
    usersList: {
      users: [],
      data: []
    },
    usersByRoles: [],
    UserInfo: {
      branch: {},
      roles: [
        {
          name: ''
        }
      ]
    },
    userCourses: [],
    CoursesList: {}
    
  },
  mutations: {
    setUsersList: (state, { list }) => {
      state.usersList = list
    },
    setUsersByRoles: (state, { list }) => {
      state.usersByRoles = list
    },
    setUserInfo: (state, { list }) => {
      state.UserInfo = list
    },
    setUserCourses: (state, { list }) => {
      state.userCourses = list
    },
    setCoursesList: (state, { list }) => {
      state.CoursesList = list
    }
  },
  actions: {}
}
